import request from '@/utils/request'

// 查询用户举报记录列表
export function listReport(query) {
  return request({
    url: '/user/report/list',
    method: 'get',
    params: query,
  })
}

// 查询用户举报记录分页
export function pageReport(query) {
  return request({
    url: '/user/report/page',
    method: 'get',
    params: query,
  })
}
export function pageRecord(query) {
  return request({
    url: '/user/exercise/record/page',
    method: 'get',
    params: query
  })
}
export function pageEatingRecord(query) {
  return request({
    url: '/eatingRecord/eatingRecord/page',
    method: 'get',
    params: query,
  })
}
// 饮水记录接口
export function drankingRecord(query) {
  return request({
    url: '/user/dranking/record/page',
    method: 'get',
    params: query,
  })
}
// 饮食分析详情接口
export function eatingAnalyze(query) {
  return request({
    url: '/eatingRecord/eatingRecord/eatingAnalyze',
    method: 'get',
    params: query,
  })
}
// 查询用户举报记录详细
export function getReport(data) {
  return request({
    url: '/user/report/detail',
    method: 'get',
    params: data,
  })
}

// 新增用户举报记录
export function addReport(data) {
  return request({
    url: '/user/report/add',
    method: 'post',
    data: data,
  })
}

// 修改用户举报记录
export function updateReport(data) {
  return request({
    url: '/user/report/edit',
    method: 'post',
    data: data,
  })
}

// 删除用户举报记录
export function delReport(data) {
  return request({
    url: '/user/report/delete',
    method: 'post',
    data: data,
  })
}
